<div class="buttonCard template-card" id="TemplateServiceCard">
    <div class="icon" style="background-image: url('/assets/svgs/Template.svg')"></div>
    <div class="title">From Template</div>

    @if (templates.length === 0) {
    <div class="content">
        <p class="template-card-text">No templates yet. Create one to define reusable services in seconds.</p>
        <a (click)="goToTemplates()" class="template-card-link">Create a template</a>
    </div>
    } @else {
    <div class="content">
        <p class="template-card-text">Template services are created from a predefined blueprint, pre-filling the configuration.</p>
    </div>
    <div class="buttonArea">
        <button (click)="onCreateClicked()" class="save" type="button">
            Create From Template
        </button>
    </div>
    }
</div>
